// extracted by mini-css-extract-plugin
export default {"FiveOffersView":"styles_FiveOffersView__fdiTS","firstAbsoluteJobOffer":"styles_firstAbsoluteJobOffer__MvCa+","secondAbsoluteJobOffer":"styles_secondAbsoluteJobOffer__1cL2C"};